import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueSelectImage from "vue-select-image";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-swatches/dist/vue-swatches.css";
require("vue-select-image/dist/vue-select-image.css");
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueSelectImage);

new Vue({
    router,
    render: function(h) {
        return h(App);
    }
}).$mount("#app");
